import { Affix, Button, Card, Collapse, Form, Layout, message, Typography } from "antd";
import { useCallback, useState } from "react";
import { Link } from "react-router-dom";
import { isMobileView } from "../../Common/AppHelper";
import Header from "../../Common/Header";
import InventoryLayOutCommon from "../../InventoryTrims/LayOut/InventoryLayOutCommon";
import BreakdownTable from "../BreakdownTable";
import SupportingMaterialTable from "../SupportingMaterialTable";
import CartonInventoryForm from "./CartonInventoryForm";

const CreateCartonInventory = (props) => {
  const { width } = props;
  const [form] = Form.useForm();
  const [breakdowns, setBreakdowns] = useState([]);
  const [supportingMaterials, setSupportingMaterials] = useState([]);
  const movement = Form.useWatch("movement_type", form);
  const hasBookingData = breakdowns.length > 0 || supportingMaterials.length > 0;
  const cardWidth = isMobileView() ? "100%" : width ? `${width}px` : "100%";

  const onBookingDataLoaded = useCallback(({ breakdowns: bd, supportingMaterials: sm }) => {
    setBreakdowns(bd || []);
    setSupportingMaterials(sm || []);
  }, []);

  const onBookingDataCleared = useCallback(() => {
    setBreakdowns([]);
    setSupportingMaterials([]);
  }, []);

  const onSave = () => {
    form.validateFields().then(() => {
      message.info("Save functionality will be implemented with backend integration.");
    });
  };

  const onDiscard = () => {
    form.resetFields();
    onBookingDataCleared();
  };

  return (
    <InventoryLayOutCommon>
      <Affix offsetTop={0}>
        <Card className="p-fixed" style={{ width: cardWidth }}>
          <Header
            title="Carton Inventory Entry"
            subTitle=""
            actions={[
              <Button key="discard" size="small" onClick={onDiscard}>
                <Link to="/inventory/carton-inventory">Discard</Link>
              </Button>,
              <Button key="save" size="small" type="primary" onClick={onSave}>
                Save
              </Button>,
            ]}
          />
        </Card>
      </Affix>

      <Layout.Content className="containt-body pt-3">
        <Form form={form} layout="vertical" name="carton-inventory-form">
          <Collapse defaultActiveKey={["order-details"]} ghost>
            <Collapse.Panel header={<Typography.Title level={5}>Order Details</Typography.Title>} key="order-details">
              <CartonInventoryForm
                form={form}
                onBookingDataLoaded={onBookingDataLoaded}
                onBookingDataCleared={onBookingDataCleared}
              />
            </Collapse.Panel>
          </Collapse>

          <BreakdownTable
            breakdowns={breakdowns}
            movement={movement}
            disabled={!movement || !hasBookingData}
          />
          <SupportingMaterialTable
            supportingMaterials={supportingMaterials}
            movement={movement}
            disabled={!movement || !hasBookingData}
          />
        </Form>
      </Layout.Content>
    </InventoryLayOutCommon>
  );
};

export default CreateCartonInventory;
